module.exports = __webpack_public_path__ + "static/img/iosCar.0370b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/bycx/assets/img/iosCar.png
// module id = /k80
// module chunks = 1